import './styles.scss';

export default {
    name: 'CustomBackButton',
    
    props: {
        url: String
    },

    computed: {
        desktop() {
            return this.$store.state.desktop;
        },

        previous_page() {
            return this.$store.state.previous_page;
        }
    },

    methods: {
        navigateBack() {
            this.$store.commit('setAnimation', 'previous');

            if (
                (this.$route.name === 'ActionPage' || this.$route.name === 'AccountPage' || this.$route.name === 'AnnotationsPage') ||
                (this.$route.name === 'EmergencyMessagesPage' && this.previous_page.name === 'ArticlePage')
            ) {
                this.$store.commit('resetMessage');
            }

            if (this.desktop) {
                if (
                    (this.$route.name === 'EmergencyEventsArticleInnerListPage') ||
                    (this.$route.name === 'EmergencyEventsArticleListPage') ||
                    (this.$route.name === 'EmergencyEventsPage') ||
                    (this.$route.name === 'PrePlansPage') ||
                    (this.$route.name === 'RecoveryArticleInnerListPage') ||
                    (this.$route.name === 'RecoveryArticleListPage') ||
                    (this.$route.name === 'RecoveryPage') ||
                    (this.$route.name === 'PreparednessArticleInnerListPage') ||
                    (this.$route.name === 'PreparednessArticleListPage') ||
                    (this.$route.name === 'PreparednessPage') ||
                    (this.$route.name === 'FixturesPage') ||
                    (this.$route.name === 'ContactsPage') ||
                    (this.$route.name === 'OperationsPage') ||
                    (this.$route.name === 'ContactDetailPage') ||
                    (this.$route.name === 'FixtureDetailPage') ||
                    (this.$route.name === 'AnnotationDetailPage') ||
                    (this.$route.name === 'DocumentPage' && this.previous_page.name === 'DocumentPage') ||
                    (this.$route.name === 'DocumentPage' && this.previous_page.name === 'PrePlansPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'EmergencyEventsPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'EmergencyEventsArticleListPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'EmergencyEventsArticleInnerListPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'PreparednessPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'PreparednessArticleListPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'PreparednessArticleInnerListPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'RecoveryPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'RecoveryArticleListPage') ||
                    (this.$route.name === 'ArticlePage' && this.previous_page.name === 'RecoveryArticleInnerListPage') ||
                    (this.$route.name === 'ArticlePage' && (this.$store.state.previous_backURL === this.$store.state.backURL && this.$route.hash !== '#linked'))
                ) {
                    this.$router.push(this.url + '#back');
                } else {
                    this.$router.go(-1);
                }
            } else {
                if (
                    (this.$route.name === 'FixturesPage') ||
                    (this.$route.name === 'ContactsPage') ||
                    (this.$route.name === 'OperationsPage')
                ) {
                    this.$router.push(this.url + '#back');
                } else {
                    this.$router.go(-1);
                }
            }
        }
    }
};